import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  padding: 20px;
  color: #e9ecef;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }

  h4 {
    color: #e9ecef;
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
  }

  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
  }
`;

export const Button = styled.button.attrs({
  type: 'submit',
})`
  background: #626ed4;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  padding: 10px;
  color: #fff;
  border-radius: 4px;
  transition: background 0.2s;

  &:hover {
    background: ${darken(0.04, '#626ed4')};
  }
`;

export const Menus = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
`;

export const NewButton = styled.button`
  background: #626ed4;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  padding: 10px;
  color: #fff;
  border-radius: 4px;
  transition: background 0.2s;

  &:hover {
    background: ${darken(0.04, '#626ed4')};
  }

  svg {
    margin-right: 5px;
  }
`;
